import { inject } from "@angular/core";
import { CanActivateFn, Router, UrlTree } from "@angular/router";
import { Store } from "@ngrx/store";
import { Observable, map, take } from "rxjs";
import { AppState } from "store/app-state";
import * as FeatureFlagSelectors from "store/feature-flags/feature-flags.selectors";

/**
 * Blocks navigation to any route while the `DownForMaintenance` flag reports it
 * is currently within a SAP maintenance window. The backend evaluates the
 * schedule and sets `isInMaintenanceWindow` to `true` only while maintenance is
 * in effect. When active, redirects to the maintenance page. Waits until the
 * feature flags have loaded before deciding so navigation is never allowed
 * through prematurely.
 */
export const maintenanceGuard: CanActivateFn = (): Observable<boolean | UrlTree> => {
  const store = inject(Store<AppState>);
  const router = inject(Router);

  return store.select(FeatureFlagSelectors.featureFlags).pipe(
    take(1),
    map((flags) => {
      const isInMaintenanceWindow =
        flags?.["DownForMaintenance"]?.isInMaintenanceWindow ?? false;
      return isInMaintenanceWindow ? router.parseUrl("/maintenance") : true;
    })
  );
};
